import React from 'react'
import styles from './ClientSection.module.css'

/* Swap each `image` with your own (R2 / CDN / local import).
   Or pass the array as a prop: <ClientSection clients={...} /> */
const CLIENTS = [
  {
    label: 'Corporate Teams & Leaders',
    image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?auto=format&fit=crop&w=700&q=80',
  },
  {
    label: 'HR & People Teams',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=700&q=80',
  },
  {
    label: 'Brand & Marketing Heads',
    image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=700&q=80',
  },
  {
    label: 'Founders & Leadership',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=700&q=80',
  },
  {
    label: 'Conference & Exhibition Organisers',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=700&q=80',
  },
]

const ClientSection = ({ clients = CLIENTS }) => {
  return (
    <section className={styles.section}>
      <div className={styles.head}>
        <span className={styles.eyebrow}>Who We Serve</span>
        <h2 className={styles.heading}>
          Our clients are as ambitious as the events we create — each experience
          crafted with strategy, creativity, and purpose
        </h2>
      </div>

      <div className={styles.grid}>
        {clients.map((c) => (
          <figure key={c.label} className={styles.tile}>
            <img src={c.image} alt={c.label} className={styles.image} />
            <span className={styles.shade} />
            <figcaption className={styles.label}>{c.label}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}

export default ClientSection